import { graphql, type OperationContext, useQuery } from "@opensea/graphql"
import { useMemo } from "react"
import { useAddress } from "@/hooks/wallet"

const query = graphql(`
  query IsTokenWatchedQuery {
    tokenWatchlist {
      id
      contractAddress
      chainIdentifier
    }
  }
`)

const OPERATION_CONTEXT: Partial<OperationContext> = {
  suspense: false,
}

export type UseIsTokenWatchedReturn = ReturnType<typeof useIsTokenWatched>

type CurrencyIdentifier = {
  contractAddress: string
  chainIdentifier: string
}

export function useIsTokenWatched(identifiers: CurrencyIdentifier[]) {
  const address = useAddress()

  const [{ data, fetching }] = useQuery(
    {
      query,
      variables: {},
      pause: !address,
      context: OPERATION_CONTEXT,
    },
    { throwOnError: false },
  )

  const isTokenWatchedMap = useMemo(() => {
    const map = new Map<string, boolean>()

    identifiers.forEach(identifier => {
      const key = `${identifier.chainIdentifier}:${identifier.contractAddress}`
      map.set(key, false)
    })

    if (data?.tokenWatchlist) {
      data.tokenWatchlist.forEach(currency => {
        const key = `${currency.chainIdentifier}:${currency.contractAddress}`
        map.set(key, true)
      })
    }

    return map
  }, [data?.tokenWatchlist, identifiers])

  return {
    isTokenWatchedMap,
    isTokenWatchedFetching: fetching,
  }
}
